const SocialLinks = ({links})=>{
    return (
        <>
        <li className="cursor-pointer w-5 hover:rotate-45 transition-all">
            <img src={links.icon} alt="" />
        </li>
        </>
    )
}
export default SocialLinks;